import type { ReactElement } from 'react';
import { Div } from '@fastnorth/kraken/components/layout';

const RaceProgressSectionSeparator = (): ReactElement => (
  <Div
    aria-hidden
    className="w-full border-0 border-t border-solid border-border"
    data-testid="race-progress-section-separator"
    spacing="7 0"
  />
);

export default RaceProgressSectionSeparator;
